// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.302 21.6152C11.5234 21.7444 11.6341 21.809 11.7903 21.8425C11.9116 21.8685 12.0884 21.8685 12.2097 21.8425C12.3659 21.809 12.4766 21.7444 12.698 21.6152C14.646 20.4788 20 16.9088 20 12.0004V7.21796C20 6.41845 20 6.01869 19.8692 5.67506C19.7537 5.3715 19.566 5.10064 19.3223 4.88589C19.0465 4.6428 18.6722 4.50243 17.9236 4.22171L12.5618 2.21103C12.3539 2.13307 12.25 2.09409 12.143 2.07864C12.0482 2.06493 11.9518 2.06493 11.857 2.07864C11.75 2.09409 11.6461 2.13307 11.4382 2.21103L6.0764 4.22171C5.3278 4.50243 4.9535 4.6428 4.67766 4.88589C4.43398 5.10064 4.24627 5.3715 4.13076 5.67506C4 6.01869 4 6.41845 4 7.21796V12.0004C4 16.9088 9.35396 20.4788 11.302 21.6152Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 11.5004L11 13.5004L15.5 9.00036M20 12.0004C20 16.9088 14.646 20.4788 12.698 21.6152C12.4766 21.7444 12.3659 21.809 12.2097 21.8425C12.0884 21.8685 11.9116 21.8685 11.7903 21.8425C11.6341 21.809 11.5234 21.7444 11.302 21.6152C9.35396 20.4788 4 16.9088 4 12.0004V7.21796C4 6.41845 4 6.01869 4.13076 5.67506C4.24627 5.3715 4.43398 5.10064 4.67766 4.88589C4.9535 4.6428 5.3278 4.50243 6.0764 4.22171L11.4382 2.21103C11.6461 2.13307 11.75 2.09409 11.857 2.07864C11.9518 2.06493 12.0482 2.06493 12.143 2.07864C12.25 2.09409 12.3539 2.13307 12.5618 2.21103L17.9236 4.22171C18.6722 4.50243 19.0465 4.6428 19.3223 4.88589C19.566 5.10064 19.7537 5.3715 19.8692 5.67506C20 6.01869 20 6.41845 20 7.21796V12.0004Z"
    />
  </svg>
);
const IconShieldFill = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconShieldFill;
